import { getOrderItemsByItemId } from './get-order-items-by-item-id';
export const getOrderItemCountByItemId = (itemId, priceRestriction) => {
    return getOrderItemsByItemId(itemId, priceRestriction).length;
};
